// apps/client/src/ui/screens/confirmTidy.tsx (M1-T16, Contract change 29) — the mayor confirms sending another resident's yard piece
// home (spec §4.4, D-39). OK sends `furniture.store { item, to: 'pockets' }`: M1-T11's handler routes it to its owner (their storage, or
// a letter when that is full), and the `item.removed` event to `out` removes the view for everyone. A reject keeps the panel open (the
// action client shows the reason); Cancel sends nothing.
import type { StringKey } from '@whiskerton/content';
import type { ItemId } from '@whiskerton/shared';
import { useState } from 'react';
import { useCommands } from '../../game/instance';
import { useGame } from '../../state/store';
import { useT } from '../i18n';
import { Button, Panel } from '../kit';
import type { ScreenDef } from '../router';

type Params = { item: ItemId; name: StringKey; owner: string };
declare module '../router' { interface ScreenParams { confirmTidy: { item: ItemId; name: StringKey; owner: string } } }

function ConfirmTidy({ params, close }: { params: Params; close: () => void }) {
  const t = useT();
  const cmd = useCommands();
  const [busy, setBusy] = useState(false);
  const ok = async () => {
    setBusy(true);
    const res = await cmd.act('furniture.store', { item: params.item, to: 'pockets' });
    setBusy(false);
    if (!res.ok) return;
    useGame.getState().toast('decor.tidyDone', { owner: params.owner });
    close();
  };
  return (
    <Panel title={t('hud.verbRemove')}>
      <div style={{ display: 'grid', gap: 14, width: 340, maxWidth: '100%' }}>
        <p style={{ margin: 0 }}>{t('decor.tidyConfirm', { object: t(params.name), owner: params.owner })}</p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <Button variant="quiet" onClick={close}>{t('common.cancel')}</Button>
          <Button disabled={busy} onClick={() => void ok()}>{t('common.ok')}</Button>
        </div>
      </div>
    </Panel>
  );
}
export const screen: ScreenDef<'confirmTidy'> = { id: 'confirmTidy', layer: 'panel', component: ({ params, close }) => <ConfirmTidy params={params} close={close} /> };
